import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';


import "./assets/vendor/bootstrap/css/bootstrap.min.css";
import "./assets/vendor/bootstrap-icons/bootstrap-icons.css";
import "./assets/vendor/boxicons/css/boxicons.min.css";
import "./assets/vendor/quill/quill.snow.css";
import "./assets/vendor/quill/quill.bubble.css"
import "./assets/vendor/remixicon/remixicon.css";
import "./assets/vendor/simple-datatables/style.css";
import "./assets/css/style.css";


import Login from './components/Login';
import Admin from './components/admin/Admin';
import Dashboard from './components/admin/Dashboard';
import Products from './components/admin/Products';
import Sales from './components/admin/Sales';
import Logout from './components/admin/Logout';
import Print from './components/print/Print';
import Sale from './components/admin/Sale';



import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


function App() {
  return (
    <BrowserRouter>

      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/admin" element={<Admin />}>
          <Route path='dashboard' element={<Dashboard />} />
          <Route path='products' element={<Products />} />
          <Route path='sales' element={<Sales />} />
          <Route path='sale' element={<Sale />} />
          <Route path='logout' element={<Logout />} />
          <Route path='print/:id' element={<Print />} />
        </Route>

      </Routes>
    </BrowserRouter>



  );
}

export default App;
